'use strict';

import {contractModel} from "../../models/contractmodel.js";

export class AnnexPdfCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	notify;
	
	item;
	
	cfg = {
		fieldName: '',
		maxFileSize: 0,
		fileFilter: {},
		saveUrl: '',
		uploadUrl: '',
		removeUrl: ''
	};
	attachmentUploadUrl;
	attfile = {
		file: {}
	};
	dragClass = '';
	attachment = {};
	
	
	constructor($scope, $filter, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.cfg.fileFilter = this.jsDataService.get('cfgPdfFilter', {});
		this.cfg.maxFileSize = this.jsDataService.get('maxFileSize', 0);
		this.cfg.saveUrl = this.jsDataService.get('cfgAnnexpdfSaveUrl');
		this.cfg.uploadUrl = this.jsDataService.get('cfgUploadUrl');
		this.cfg.removeUrl = this.jsDataService.get('cfgAnnexpdfRemoveUrl', '');
		this.cfg.fieldName = this.jsDataService.get('cfgFieldName', '');
		this.item = new contractModel(this.jsDataService.get('item', {}), this.$filter, this.jsDataService);
		if(typeof(this.item[this.cfg.fieldName]) !== 'undefined' && this.item[this.cfg.fieldName] > 0){
			this.setAttachment(this.item);
		}
	}
	
	isFile(){
		return (typeof(this.attachment.file_id) !== 'undefined' && this.attachment.file_id > 0);
	}
	
	fileUploaded($file, $message, $flow){
		if($file.response.success){
			this.attfile.file.file_id = $file.response.fileId;
			this.attfile.file.done = true;
			this.saveAttachment(this.attfile);
		}
	}
	
	setAttachment(itemData){
		this.attachment = {
			file_id: itemData[this.cfg.fieldName],
			title: itemData[this.cfg.fieldName+'_title'],
			url: itemData[this.cfg.fieldName+'_url'],
			fieldName: this.cfg.fieldName
		};
	}
	
	filesAdded($files){
		return true;
	}

	fileAdded($file) {
		const ext = $file.getExtension().toLowerCase();

		if (!this.cfg.fileFilter[ext]) {
			this.notify(this.$filter('tr')('file_pdf_allowed'), true);
			return false;
		}

		if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
			this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
			return false;
		}

		if(!this.activeUpload()){
			return false;
		}

		this.addFlowFile($file);
		return true;
	}
	
	fileSubmited(){
		this.attfile.flow.upload();
	}
	
	activeUpload(){
		return true;
	}

	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}

	classOffDrag(value){
		this.dragClass = value;
	}
	
	addFlowFile($file){
		let file = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.attfile.file = file;
	}
	
	saveAttachment(attachment){
		let data = {
			file_id: attachment.file.file_id,
			title: attachment.file.file_name,
			fieldName: this.cfg.fieldName
		};
		if(this.cfg.saveUrl && this.cfg.saveUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.cfg.saveUrl,
				method: 'POST',
				data: data
			}).then((response) => {
				if(response.data.success && typeof(response.data.item) !== 'undefined'){
					this.setAttachment(response.data.item);
//					this.attachment = response.data.item;
					this.attfile.file = {};
				}
			}, () => {});
		}
		else{
			console.log('no url ', this.cfg.saveUrl);
		}
	}
	
	removePdf(ev){
		if(this.cfg.removeUrl !== ''){
			const confirmTexts = this.jsDataService.get('annexpdfRemoveConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.removeUrl,
					method: 'GET',
					responseType: 'json',
					params: {
						fieldName: this.cfg.fieldName,
						id: this.attachment.file_id
					}
				}).then((results) => {
					if(results.data.success){
						this.attachment = {};
					}
				});
			}, () => {});
		}
	}
	
	
}